import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconSearch = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-search" data-icon="icon-search" aria-hidden="true" {...props} ref={ref}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>);
});

IconSearch.displayName = 'IconSearch';
